import React, { useState } from "react";
import "./Navbar.scss";
import {
  Nav,
  NavLink,
  Bars,
  Close,
  NavMenu,
  MobileNavMenu,
} from "../Navbar/components/NavbarElements";

const NAVBAR_OPTIONS = [
  {
    key: "navbar_services",
    route: "/services",
    label: "Services",
  },
  {
    key: "navbar_careers",
    route: "/careers",
    label: "Careers",
  },

  {
    key: "navbar_about_us",
    route: "/about-us/our-company",
    label: "About us",
  },
  {
    key: "navbar_contact_us",
    route: "/contact-us",
    label: "Contact us",
  },
];

const Navbar = () => {
  const [isNavbarOptionVisible, setIsNavbarOptionVisible] = useState(false);

  const toggleNavbarOption = () => {
    setIsNavbarOptionVisible(!isNavbarOptionVisible);
  };

  const renderNavbarOption = ({ isMobile }) => {
    const toggleNavLinkClick = () => {
      setIsNavbarOptionVisible(false);
    };

    return NAVBAR_OPTIONS.map((option) => {
      return (
        <>
          {isMobile && isNavbarOptionVisible ? (
            <div>
              <Close onClick={toggleNavbarOption} size="lg" />
            </div>
          ) : null}
          <NavLink
            to={option?.route}
            activeStyle
            onClick={toggleNavLinkClick}
            key={option?.key}
          >
            <div className="navbarOptions">{option?.label}</div>
          </NavLink>
        </>
      );
    });
  };

  return (
    <>
      <Nav>
        <NavLink to="/">
          <img
            src="/workoza_logo.png"
            alt="no logo"
            height={48}
            width={172}
            className="logoContainer"
          />
        </NavLink>
        {!isNavbarOptionVisible ? <Bars onClick={toggleNavbarOption} /> : null}
        <NavMenu>{renderNavbarOption({ isMobile: false })}</NavMenu>
        {isNavbarOptionVisible ? (
          <MobileNavMenu>
            {renderNavbarOption({ isMobile: true })}
          </MobileNavMenu>
        ) : null}
      </Nav>
    </>
  );
};

export default Navbar;
